import { Action } from 'redux';

import ActionPayloadNumber from '../interfaces/actions/ActionPayloadNumber';

import * as Const from '../constants';

export const productInitAction = (): Action => {
  return {
    type: Const.PRODUCT_INIT,
  };
};

export const fetchReceiveProductAction = (payload: number): ActionPayloadNumber => {
  return {
    type: Const.PRODUCT_RECEIVE,
    payload,
  };
};
